module.exports = __webpack_public_path__ + "static/img/Dylan_Shiel_desktop.10a08e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dylan_Shiel_desktop.jpg
// module id = VjiN
// module chunks = 0